import React from "react";
import Navbar from "./Partials/Navbar";

const Header = () => {
  return (
    <div>
      <h1>  Divine Counter.</h1>
      <Navbar />
    </div>
  );
};

export default Header;
